export var defaultAPIError = 'Your request could not be processed. Please try again.';
//# sourceMappingURL=constants.js.map